import * as React from "react";
const SvgFiRrHomeHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-home-heart_svg__a)">
      <path
        fill="#062147"
        d="M12.136 19.103a2.3 2.3 0 0 1-1.45-.513c-1.401-1.122-4.051-3.853-4.051-6.159 0-1.892 1.458-3.43 3.25-3.43.89 0 1.675.318 2.25.852.575-.533 1.36-.852 2.25-.852 1.792 0 3.25 1.539 3.25 3.43 0 2.307-2.649 5.038-4.05 6.16a2.3 2.3 0 0 1-1.449.512M9.885 11c-.689 0-1.25.642-1.25 1.43 0 1.276 1.917 3.49 3.301 4.598a.31.31 0 0 0 .399 0c1.384-1.108 3.3-3.322 3.3-4.599 0-.789-.561-1.43-1.25-1.43-.622 0-1.25.374-1.25 1.209a1 1 0 1 1-2 0c0-.893-.674-1.209-1.25-1.209zM19 24H5c-2.757 0-5-2.243-5-5V9.724C0 8.06.823 6.511 2.203 5.579l7-4.724a4.98 4.98 0 0 1 5.595 0l7 4.723A5 5 0 0 1 24 9.723v9.276A5.007 5.007 0 0 1 19 24M12.001 1.998c-.585 0-1.169.172-1.679.516l-7 4.723A3 3 0 0 0 2 9.724V19c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V9.724c0-.999-.494-1.929-1.321-2.487l-7-4.723a3 3 0 0 0-1.678-.516"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-home-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHomeHeart;
